<template>
    <div>
        <v-toolbar app color="black" dark>
            <v-toolbar-title data-cy="titleBtn" class="mt-2">
                <img
                    class="menuLogo ml-0 "
                    src="https://www.icron.it/virtualdrone/assets/images/Logo.png"
                    style="height: 45px"
                />
                <img
                    class="menuLogo ml-4"
                    src="../assets/images/ari.png"
                    style="height: 40px"
                />

            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-flex flex xs12 sm12 md12 lg12>
            <map-detail
                v-if="showMap"
                :idEvento="idEvento"
                :configuration="configuration"
                :listaPoi="pois"
                :settings="configEvento"
                :raceTitle="raceTitle"
            ></map-detail>
        </v-flex>

    </div>
</template>

<script>
import JustMeVue from '../components/JustMe.vue';

export default {
    components: {
        mapDetail: JustMeVue,
    },
    name: 'TrackMe',
    data() {
        return {

            idEvento: 0,
            idAttivita: -1,
            token: null,

            fields: { racename: 'VIRTUAL DRONE' },
            showMap: false,


            pois: [],
            tracks: [],
            areas: [],

            raceTitle: '',
            configuration: undefined,
        };
    },
    mounted() {
        var self = this;

        this.idEvento = this.$route.params.raceID;
       

        this.loadMappa();
       // this.loadEvento();
    },

    methods: {
        loadMappa() {
            const _url =
                this.getDataURL() +
                'getARIGPSConfig?idGara=' +
                this.idEvento ;
            console.log(_url)

            this.getRemoteService(_url).then((response) => {
               // console.log('GPX>>' + response + '<<');

                const res = JSON.parse(response);

                this.configuration = [];
                let _conf = {
                    id: 1906,
                    descrizione: 'TEST TATA',
                    note: '37bbcffd177744a0adb648c6645ac1f3',
                    cognome: 'TATARANO',
                    nome: 'ALBERTO',
                    data: '2021-01-07',
                    sport: 'RUNNING',
                    idGara: '20200859',
                    pathGpx:
                        '/profilo-icron/31/attivita/IDX2NnztoXVVCAp-e4V3Xg0YDljbmtJwTVCYNy4aWAk=_20200859.gpx',
                    lunghezza: 20375.7,
                    durata: '01:52:41.000',
                    media: '5,32 Min/Km',

                    passo: '0'
                };

                _conf.type = 'track';
                _conf.color = '#FF0000';
                _conf.distance = _conf.lunghezza;

                var points = [];
                const pMax = parseInt(res.puntoMax)
                for (let i = 0; i<pMax; i=i+10) {
                    const indexP = ''+i;
                    const latLon = res.mappaPunti[indexP].split(",");
                    points.push([parseFloat(latLon[0]), parseFloat(latLon[1])]);
                }
                //_conf.gpx = response;
                _conf.coordinates = points;
                _conf.mappaPoints = res.mappaPunti;
                _conf.puntoMax = pMax;
                _conf.mapType = 'outdoor'
                this.configuration.push(_conf);

                this.showMap = true;

            }); //fine
        },

        loadEvento() {
           

            console.log(this.idEvento);
            const _url =
                this.getDataURL() +
                'getFile?idGara=' +
                this.idEvento +
                '&fileName=remoteTrackConfiguration' +
                this.idEvento +
                '_' +
                this.paramID +
                '.txt';
            //  if (this.local) _url = "/local/"+ this.idEvento+"/localLiveConfiguration" + this.idEvento + "_" + this.paramID + ".csv";
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log('>>' + response + '<<');
                if (response !== '') {
                    this.configRace(response);
                } else {
                   // alert('Evento non configurato.');
                }
            }); //fine
        },

        configRace(response) {
            console.log('AAA');
            this.configEvento = this.properties2Object(response);
            this.configOK = true;

            if (this.local !== undefined) {
                const toks = this.local.split(',');
                toks.forEach((tok) => {
                    if (tok.indexOf('=') !== -1) {
                        const keyval = tok.split('=');
                        this.configEvento[keyval[0]] = this.normalize(
                            keyval[1]
                        );
                    }
                });
            }

            console.log('CERCA POI');
            for (let i = 1; i < 100; i++) {
                //alert(this.configEvento['split' + i]) ;
                let _poi = this.configEvento['poi' + i];
                if (_poi !== undefined) {
                    this.configEvento.numPoi = i;

                    console.log('POI:' + _poi);

                    let _myPoi = { id: i };

                    const toks = _poi.split(';');
                    toks.forEach((tok) => {
                        if (tok.indexOf('=') !== -1) {
                            const keyval = tok.split('=');
                            const value = this.normalize(keyval[1]);
                            _myPoi[keyval[0]] = value;
                        }
                    });

                    this.pois.push(_myPoi);
                    console.log(_myPoi);
                } else {
                    break;
                }
            }

            this.raceTitle = this.configEvento['raceTitle'];
        },

    },
};
</script>


